// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"b7ab6c92","430":"92e7553d","530":"0752714d","655":"546b1e03"}[chunkId] + ".chunk.js";
};